import { render } from "./TestWritingContext.vue?vue&type=template&id=0bf5dc12&scoped=true"
import script from "./TestWritingContext.vue?vue&type=script&lang=js"
export * from "./TestWritingContext.vue?vue&type=script&lang=js"

import "./TestWritingContext.vue?vue&type=style&index=0&id=0bf5dc12&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bf5dc12"]])

export default __exports__